import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SwitchingDialogService {
    private onToggleDialogType$: Subject<DialogData>;

    constructor() {
        this.onToggleDialogType$ = new Subject();
    }

    get getToggleDialogObservable(): Observable<DialogData> {
        return this.onToggleDialogType$.asObservable();
    }

    onToggleDialogType(data: DialogData): void {
        this.onToggleDialogType$.next(data);
    }

}

export interface DialogData {
    dialogType: string;
    recordData: any;
}
